module.exports = __webpack_public_path__ + "img/sre.ea495b0a.png";